/**
 * ② 现价 + sparkline + 标注。
 * 涨 Figma：94542:219928 / 跌 Figma：94103:25534
 */

import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import { cn } from "utils";
import { MiniSparklineChart } from "./miniCharts/MiniSparklineChart";
import { SignalCardShell } from "./SignalCardShell";
import type {
  ChartAnnotationPoint,
  PriceChangeDirection,
  SignalCardAssetProps,
} from "./types";

export interface AssetPriceSparklineCardProps extends SignalCardAssetProps {
  price: string;
  priceChange: string;
  priceChangePercent: string;
  changeDirection: PriceChangeDirection;
  chartPoints: number[];
  annotation?: ChartAnnotationPoint;
}

export const AssetPriceSparklineCard: React.FC<
  AssetPriceSparklineCardProps
> = ({
  price,
  priceChange,
  priceChangePercent,
  changeDirection,
  chartPoints,
  annotation,
  ...asset
}) => {
  const isUp = changeDirection === "up";
  const isDown = changeDirection === "down";

  return (
    <SignalCardShell {...asset}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex flex-col gap-1">
          <p className="headline_regular_l text-content_primary">{price}</p>
          <div className="flex items-center gap-1">
            {isUp || isDown ? (
              <OspIcons
                name="upvote"
                size={12}
                className={cn({
                  "text-content_accent1_primary": isUp,
                  "scale-y-[-1] text-content_accent2_primary": isDown,
                })}
              />
            ) : null}
            <span
              className={cn("body_medium_m", {
                "text-content_accent1_primary": isUp,
                "text-content_accent2_primary": isDown,
                "text-content_tertiary": !isUp && !isDown,
              })}
            >
              {priceChange} ({priceChangePercent})
            </span>
          </div>
        </div>
        <MiniSparklineChart
          points={chartPoints}
          direction={changeDirection === "flat" ? "up" : changeDirection}
          annotation={annotation}
        />
      </div>
    </SignalCardShell>
  );
};
